import { render, staticRenderFns } from "./PropostaTerapeuticaViewComponent.vue?vue&type=template&id=de54fd56"
import script from "./PropostaTerapeuticaViewComponent.vue?vue&type=script&lang=js"
export * from "./PropostaTerapeuticaViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports